/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playbar_SectionsInputs */

const en_playbar_sections = /** @type {(inputs: Playbar_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sections`)
};

const es_playbar_sections = /** @type {(inputs: Playbar_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secciones`)
};

/**
* | output |
* | --- |
* | "Sections" |
*
* @param {Playbar_SectionsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const playbar_sections = /** @type {((inputs?: Playbar_SectionsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playbar_SectionsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_playbar_sections(inputs)
	return en_playbar_sections(inputs)
});